module.exports = __webpack_public_path__ + "img/Speaker=Ge Wang.585f5f44.png";